module.exports = __webpack_public_path__ + "static/media/432215628_920586836200939_3610917464858961251_n.81673c0f.jpg";